export enum Role {
    CLIENTE = 'CLIENTE',
    ADMIN = 'ADMIN'
}